import { html, renderIf } from '../../utility/lit-entity';
import './device-list-item';
import './device-monitoring-chart';

export const renderListItem = ({ name, device, detailsViewable, onDetailsClicked }) => {
  const { href } = device.getLinkByRel('self');

  const visibleLayers = [];

  switch (name) {
  case 'dead':
    visibleLayers.push('levels', 'battery', 'cell', 'batteryTemperature');
    break;
  case 'battery':
    visibleLayers.push('battery', 'batteryTemperature');
    break;
  case 'sensor':
  case 'refill-analysis':
  case 'rotation-score':
  case 'no-valid-levels':
  default:
    visibleLayers.push('levels');
    break;
  }

  return html`
    <device-list-item
      flagname="${name}"
      ?detailsviewable="${detailsViewable}"
      .href="${href}"
      @detailsviewablechange="${onDetailsClicked}"
    >
      ${renderIf(detailsViewable, () => html`
        <device-monitoring-chart
          slot="lower-content"
          visible-layers="${JSON.stringify(visibleLayers)}"
          .href="${detailsViewable && href}"
          .hide="${!detailsViewable}"
        ></device-monitoring-chart>
      `)}
    </device-list-item>
  `;
};
